module.exports = __webpack_public_path__ + "img/profesor.364e4d8a.png";